<template>
  <div class="pages">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="校友发布" name="0">
        <div class="filter">
          <div>
            <el-form size="small" :inline="true">
              <el-form-item label="标签">
                <el-select v-model="formInline.sign">
                  <el-option
                    :label="v.name"
                    :value="v.value"
                    v-for="(v, i) in labelList"
                    :key="i"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="状态">
                <el-select v-model="formInline.state">
                  <el-option
                    :label="v.name"
                    :value="v.value"
                    v-for="(v, i) in stateList"
                    :key="i"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="学校" v-if="$store.state.userinfo.isSuper">
                <el-select
                  clearable
                  v-model="schoolValue"
                  placeholder="请选择学校"
                >
                  <el-option
                    v-for="item in schoolList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="选择日期">
                <el-date-picker
                  v-model="formInline.dateValue"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-form>
          </div>
          <div class="search">
            <el-form size="small" :inline="true">
              <el-form-item label="关键字">
                <el-input
                  v-model="formInline.keyWord"
                  placeholder="请输入关键词查询"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="searcList(1)">搜索</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="企业发布" name="1">
        <div class="filter">
          <div>
            <el-form size="small" :inline="true">
              <el-form-item label="标签">
                <el-select v-model="formInline.sign">
                  <el-option
                    :label="v.name"
                    :value="v.value"
                    v-for="(v, i) in labelList"
                    :key="i"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="状态">
                <el-select v-model="formInline.state">
                  <el-option
                    :label="v.name"
                    :value="v.value"
                    v-for="(v, i) in stateList"
                    :key="i"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="学校" v-if="$store.state.userinfo.isSuper">
                <el-select
                  clearable
                  v-model="schoolValue"
                  placeholder="请选择学校"
                >
                  <el-option
                    v-for="item in schoolList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="选择日期">
                <el-date-picker
                  v-model="formInline.dateValue"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-form>
          </div>
          <div class="search">
            <el-form size="small" :inline="true">
              <el-form-item label="关键字">
                <el-input
                  v-model="formInline.keyWord"
                  placeholder="请输入关键词查询"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="searcList(2)">搜索</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="学校资讯" name="2">
        <div class="filter">
          <div>
            <el-form size="small" :inline="true">
              <el-form-item label="标签">
                <el-select v-model="formInline.sign">
                  <el-option
                    :label="v.name"
                    :value="v.value"
                    v-for="(v, i) in labelList"
                    :key="i"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="状态">
                <el-select v-model="formInline.state">
                  <el-option
                    :label="v.name"
                    :value="v.value"
                    v-for="(v, i) in stateList"
                    :key="i"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="学校" v-if="$store.state.userinfo.isSuper">
                <el-select
                  clearable
                  v-model="schoolValue"
                  placeholder="请选择学校"
                >
                  <el-option
                    v-for="item in schoolList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="选择日期">
                <el-date-picker
                  v-model="formInline.dateValue"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-form>
          </div>
          <div class="search">
            <el-form size="small" :inline="true">
              <el-form-item label="关键字">
                <el-input
                  v-model="formInline.keyWord"
                  placeholder="请输入关键词查询"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="searcList(3)">搜索</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <div class="table">
      <!--校友发布  -->
      <el-table
        v-if="activeName == 0"
        :data="tableData"
        height="5.28rem"
        max-height="5.28rem"
      >
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="title"
          label="标题"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          property="userName"
          label="发布人用户名"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.userName">{{ scope.row.userName }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column property="name" label="真实姓名" align="center">
        </el-table-column>
        <el-table-column
          property="sysSignStr"
          label="标签"
          :show-overflow-tooltip="true"
          align="center"
        >
        </el-table-column>
        <el-table-column property="state" label="状态" align="center">
          <template slot-scope="scope">
            <p v-if="scope.row.state == 0">正常</p>
            <p v-if="scope.row.state == 1">屏蔽</p>
          </template>
        </el-table-column>
        <el-table-column
          property="forwardCount"
          sortable
          label="分享数"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="collectCount"
          sortable
          label="收藏数"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="commentCount"
          sortable
          label="评论数"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="readCount"
          sortable
          label="阅读数"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="creationTime"
          sortable
          label="发布时间"
          align="center"
        >
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button @click="see(scope.row, 1)" type="text" size="medium"
              >查看</el-button
            >
            <el-button
              style="color: #fa0"
              v-if="scope.row.state == 0"
              @click="shield(scope.row, 1)"
              type="text"
              size="medium"
              >屏蔽</el-button
            >
            <el-button
              v-if="scope.row.state == 1"
              @click="shieldRecover(scope.row, 1)"
              type="text"
              size="medium"
              >恢复</el-button
            >
            <el-button
              style="color: #f00"
              @click="del(scope.row, 1)"
              type="text"
              size="medium"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!--企业发布  -->
      <el-table
        v-if="activeName == 1"
        :data="tableData"
        height="5.28rem"
        max-height="5.28rem"
      >
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="title"
          label="标题"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          property="businessName"
          label="发布企业名称"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="userName"
          label="发布人用户名"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.userName">{{ scope.row.userName }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column property="name" label="真实姓名" align="center">
        </el-table-column>
        <el-table-column
          property="forwardCount"
          sortable
          label="分享数"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="collectCount"
          sortable
          label="收藏数"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="commentCount"
          sortable
          label="评论数"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="readCount"
          sortable
          label="阅读数"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="creationTime"
          sortable
          label="发布时间"
          align="center"
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button @click="see(scope.row, 2)" type="text" size="medium"
              >查看</el-button
            >
            <el-button
              style="color: #fa0"
              v-if="scope.row.state == 0"
              @click="shield(scope.row, 2)"
              type="text"
              size="medium"
              >屏蔽</el-button
            >
            <el-button
              v-if="scope.row.state == 1"
              @click="shieldRecover(scope.row, 2)"
              type="text"
              size="medium"
              >恢复</el-button
            >
            <el-button
              style="color: #f00"
              @click="del(scope.row, 2)"
              type="text"
              size="medium"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!--学校资讯  -->
      <el-button
        v-if="activeName == 2&&!$store.state.userinfo.isSuper"
        type="primary"
        size="medium"
        @click="publishMsgHanle"
        >发布资讯</el-button
      >
      <el-button
        v-if="activeName == 2&& $store.state.userinfo.isSuper"
        type="primary"
        size="medium"
        @click="dialogSetHandle"
        >默认封面设置</el-button
      >
      <el-table
        v-if="activeName == 2"
        :data="tableData"
        height="5.28rem"
        max-height="5.28rem"
      >
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="title"
          label="标题"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          property="schoolName"
          label="发布学校名称"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="userName"
          label="发布人用户名"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.userName">{{ scope.row.userName }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column property="name" label="真实姓名" align="center">
        </el-table-column>
        <el-table-column
          property="collectCount"
          sortable
          label="收藏数"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="commentCount"
          sortable
          label="评论数"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="readCount"
          sortable
          label="阅读数"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="creationTime"
          sortable
          label="发布时间
        "
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button @click="see(scope.row, 3)" type="text" size="medium"
              >查看</el-button
            >
            <el-button
              style="color: #fa0"
              v-if="scope.row.state == 0"
              @click="shield(scope.row, 3)"
              type="text"
              size="medium"
              >屏蔽</el-button
            >
            <el-button
              v-if="scope.row.state == 1"
              @click="shieldRecover(scope.row, 3)"
              type="text"
              size="medium"
              >恢复</el-button
            >
            <el-button
              style="color: #f00"
              @click="del(scope.row, 3)"
              type="text"
              size="medium"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="pages justify-end">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="currentSize"
          layout="  prev, pager, next,  sizes, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="查看"
      :visible.sync="centerDialogVisible"
      width="60%"
      center
    >
      <contentDetail
        :currArticleInfo="currArticleInfo"
        :isShowSign="activeName"
      ></contentDetail>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="发布资讯"
      :destroy-on-close="true"
      width="50%"
      :visible.sync="dialogFormVisible"
      @close="close"
    >
      <el-form :model="form" label-width="100px">
        <el-form-item label="资讯类型">
          <el-select
            style="width: 80%"
            clearable
            v-model="form.type"
            placeholder="请选择资讯类型"
          >
            <el-option
              v-for="item in msgList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="标题">
          <el-input
          placeholder="请输入标题"
            style="width: 80%"
            v-model="form.title"
            maxlength="20"
            show-word-limit
          />
        </el-form-item>

        <el-form-item label="封面图片">
          <el-upload
            class="upload-demo"
            :on-change="handleUploadChange"
            :on-remove="handleRemove"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :file-list="fileList"
            accept="image/*"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过5MB
            </div>
          </el-upload>
          <el-button type="text" @click="useDefaultCover"
            >使用默认封面</el-button
          >
        </el-form-item>

        <el-form-item label="内容">
          <!-- <div id="editor-container" style="border: 1px solid #ccc"></div> -->
          <div class="rich-text-wrapper">
            <wordEdit v-model="form.content" />
            <!-- <div
            ref="editorContainer"
            id="editor-container"
            style="border: 1px solid #ccc"
          ></div> -->
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">发布</el-button>
      </span>
    </el-dialog>
    <!-- 默认封面设置 -->
    <el-dialog
      :title="coverTitle"
      :visible.sync="coverDialogSet"
      :before-close="handleClose"
      width="70%"
    >
      <div class="search">
        <el-form size="small" :inline="true">
          <el-form-item label="">
            <el-input
              clearable
              v-model="coverSet.Key"
              placeholder="请输入关键词查询"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否启用：">
            <el-select clearable v-model="coverSet.IsEnable">
              <el-option
                :label="v.name"
                :value="v.value"
                v-for="(v, i) in coverSetLabel"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="coverSearch">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-button type="primary" v-if="coverTitle=='默认封面设置'" @click="addDialogVisible = true"
        >添加</el-button
      >

      <el-table :data="adminList" style="width: 100%">
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="coverName"
          label="图片名称"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 60px"
              :src="fullCoverImageUrl(scope.row.coverImage)"
              :preview-src-list="[fullCoverImageUrl(scope.row.coverImage)]"
              fit="cover"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.isEnable ? 'success' : 'danger'"
              size="small"
            >
              {{ scope.row.isEnable ? "启用" : "禁用" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button
            v-if="coverTitle=='默认封面设置'"
              :style="scope.row.isEnable ? { color: '#f00' } : null"
              :type="'text'"
              size="mini"
              @click="toggleCoverStatus(scope.row)"
            >
              {{ scope.row.isEnable ? "禁用" : "启用" }}
            </el-button>
            <el-button
            v-if="coverTitle=='默认封面设置'"
              type="text"
              size="mini"
              @click="openEditDialog(scope.row)"
            >
              修改
            </el-button>
            <el-button v-if="coverTitle=='选择封面设置'" type="text" size="mini" @click="useCover(scope.row)">
              使用
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pages justify-end">
        <el-pagination
          @size-change="handleCoverSizeChange"
          @current-change="handleCoverPageChange"
          :current-page="coverPagination.currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="coverPagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="coverPagination.total"
        >
        </el-pagination>
      </div>
    </el-dialog>

    <!-- 新增弹窗 -->
    <el-dialog
      title="新增默认封面"
      :visible.sync="addDialogVisible"
      width="30%"
      @close="resetAddForm"
    >
      <el-form :model="addForm" label-width="100px">
        <!-- 图片名称 -->
        <el-form-item label="图片名称">
          <el-input
            v-model="addForm.name"
            placeholder="请输入图片名称"
          ></el-input>
        </el-form-item>

        <!-- 图片上传 -->
        <el-form-item label="上传图片">
          <el-upload
            class="upload-demo"
            :on-change="handleAddCoverUpload"
            :on-remove="handleAddCoverRemove"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :file-list="addCoverFileList"
            accept="image/*"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过5MB
            </div>
          </el-upload>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAddForm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 修改弹窗 -->
    <el-dialog
      title="修改默认封面"
      :visible.sync="editDialogVisible"
      width="30%"
      @close="resetEditForm"
    >
      <el-form :model="editForm" label-width="100px">
        <!-- 图片名称 -->
        <el-form-item label="图片名称">
          <el-input
            v-model="editForm.name"
            placeholder="请输入图片名称"
          ></el-input>
        </el-form-item>

        <!-- 图片上传 -->
        <el-form-item label="上传图片">
          <el-upload
            class="upload-demo"
            :on-change="handleEditCoverUpload"
            :on-remove="handleEditCoverRemove"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :file-list="editCoverFileList"
            accept="image/*"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过5MB
            </div>
          </el-upload>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEditForm">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import contentDetail from "../../components/contentDetail.vue";
import wordEdit from "@/components/RichWord/WordEdit";
import {
  AddJournaArticleCoverReq,
  UpdateJournaArticleCoverReq,
  DisableOrEnableJournaArticleCoverReq,
  GetJournaArticleCoverListReq,
  PublishJournaArticleApi
} from "@/request/requestApi";
import E from "wangeditor";

export default {
  data() {
    return {
      coverTitle: "",
      coverSet: {
        Key: "",
        IsEnable: undefined
      },
      coverPagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      addDialogVisible: false, // 新增弹窗显示状态
      editDialogVisible: false, // 修改弹窗显示状态
      addForm: {
        name: "", // 图片名称
        coverUrl: "" // 上传的图片URL
      },
      editForm: {
        id: "", // 图片ID
        name: "", // 图片名称
        coverUrl: "" // 上传的图片URL
      },
      addCoverFileList: [], // 新增上传的文件列表
      editCoverFileList: [], // 修改上传的文件列表
      schoolVal: { keyword: "" },
      adminList: [],
      coverDialogSet: false,
      dialogFormVisible: false,
      form: {
        type: "",
        title: "",
        cover: "",
        content: ""
      },
      editor: null,
      uploadUrl: "",
      uploadHeaders: {
        Authorization: `Bearer ${localStorage.getItem("token")}` // 如果需要认证
      },
      fileList: [],
      schoolValue: "",
      //学校
      schoolList: [],
      msgList: [
        { name: "校园活动", value: "0" },
        { name: "校园资讯", value: "1" }
      ],
      centerDialogVisible: false,
      activeName: 0,
      tableData: [],
      formInline: {
        state: "",
        dateValue: "",
        keyWord: "",
        sign: ""
      },
      stateList: [
        { name: "全部", value: "" },
        { name: "正常", value: 0 },
        { name: "屏蔽", value: 1 }
      ],
      labelList: [
        { name: "全部", value: "" },
        { name: "企业招聘", value: "企业招聘" },
        { name: "生活", value: "生活" },
        { name: "租房", value: "租房" },
        { name: "找工作", value: "找工作" },
        { name: "其他", value: "其他" }
      ],
      coverSetLabel: [
        { name: "是", value: true },
        { name: "否", value: false }
      ],
      //内容信息详情
      currArticleInfo: {},
      //翻页
      currentPage: 1,
      currentSize: 10,
      totalCount: 0
    };
  },
  created() {
    this.getArticleList();
    this.getSchoolList();
  },
  mounted() {
    this.uploadUrl = `${window.api.apiurl}/api/Common/UploadFile`;
  },
  methods: {
    // 发布资讯提交
    handleSubmit() {
      // 表单验证
      if (!this.form.type) {
        this.$message.error("请选择资讯类型");
        return;
      }
      if (!this.form.title || this.form.title.trim().length === 0) {
        this.$message.error("请输入标题");
        return;
      }
      if (!this.form.content || this.form.content.trim().length === 0) {
        this.$message.error("请输入内容");
        return;
      }
      if (!this.form.cover) {
        this.$message.error("请上传封面图片");
        return;
      }

      // 准备请求参数
      const params = {
        title: this.form.title,
        templateUrl: this.form.cover, // 封面图片URL
        content: this.form.content,
        journaArticleType: parseInt(this.form.type) // 转换为数字类型
      };

      // 显示加载中
      const loading = this.$loading({
        lock: true,
        text: "发布中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      // 调用API
      PublishJournaArticleApi(params)
        .then(res => {
          loading.close();
          if (res.succeed) {
            this.$message.success("发布成功");
            this.dialogFormVisible = false;
            this.resetForm();
            // 刷新列表
            this.getArticleList(3, this.currentPage, this.currentSize);
          } else {
            this.$message.error(res.error || "发布失败");
          }
        })
        .catch(err => {
          loading.close();
          console.error("发布失败:", err);
          this.$message.error("发布失败，请稍后重试");
        });
    },

    // 重置表单
    resetForm() {
      this.form = {
        type: "",
        title: "",
        cover: "",
        content: ""
      };
      this.fileList = [];
      if (this.editor) {
        this.editor.txt.clear();
      }
    },

    // 关闭弹窗
    close() {
      this.resetForm();
    },

    // 处理上传文件变化
    handleUploadChange(file, fileList) {
      if (file.status === "success") {
        this.form.cover = file.response.data; // 假设接口返回格式为 { data: 'url' }
      }

      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]];
      }
    },

    // 处理移除文件
    handleRemove(file, fileList) {
      this.form.cover = "";
      this.fileList = fileList;
    },
    searcList(type) {
      this.currentPage = 1;
      this.getArticleList(type, this.currentPage);
    },
    //获取学校
    getSchoolList(pageIndex = 1, pageSize = 9999999) {
      var params = {
        PageIndex: pageIndex,
        PageSize: pageSize
      };

      var url = this.$dataConver.getUrl("/admin/School/GetSchoolList", params);

      this.$api.get(url).then(res => {
        if (res.succeed) {
          this.schoolList = res.data.items;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取信息列表
    getArticleList(type = 1, pageIndex = 1, pageSize = 10) {
      var query = {
        type: type,
        state: this.formInline.state,
        schoolid: this.schoolValue,
        pageIndex: pageIndex,
        pageSize: pageSize,
        starttime:
          this.formInline.dateValue == null ? "" : this.formInline.dateValue[0],
        endtime:
          this.formInline.dateValue == null ? "" : this.formInline.dateValue[1],
        title: this.formInline.keyWord,
        sign: this.formInline.sign
      };
      var url = this.$dataConver.getUrl("/admin/Article/GetArticleList", query);
      this.$api.get(url).then(res => {
        if (res.succeed) {
          this.tableData = res.data.items;
          this.totalCount = res.data.total;
          this.tableData.forEach(element => {
            element.creationTime = element.creationTime.substring(0, 10);
          });
          // console.log(this.tableData);
          if (this.tableData.length <= 0 && this.currentPage > 1) {
            this.getArticleList(--this.currentPage);
          }
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取内容信息详情
    getArticleInfo(type, id) {
      this.$api
        .get("/admin/Article/GetArticleInfo?type=" + type + "&id=" + id)
        .then(res => {
          if (res.succeed) {
            this.currArticleInfo = "";
            this.currArticleInfo = res.data;
          } else {
            this.$message.error(res.error);
          }
        });
    },
    //数据复位
    dataReset() {
      this.formInline = {
        state: "",
        dateValue: "",
        keyWord: "",
        sign: ""
      };
      this.totalCount = 0;
      this.currentPage = 1;
      this.currentSize = 10;
    },
    //选项卡切换
    handleClick(tab, event) {
      // console.log(tab, event);
      this.dataReset();
      if (this.activeName == 0) {
        this.getArticleList(1);
      } else if (this.activeName == 1) {
        this.getArticleList(2);
      } else if (this.activeName == 2) {
        this.getArticleList(3);
      }
    },
    //内容状态更改
    updateArticleInfo(type, id, state) {
      this.$api
        .post(
          "/admin/Article/UpdateArticleState?type=" +
            type +
            "&id=" +
            id +
            "&state=" +
            state
        )
        .then(res => {
          if (res.succeed) {
            this.$message.success("操作成功！");
            this.getArticleList(type, this.currentPage, this.currentSize);
          } else {
            this.$message.error(res.error);
          }
        });
    }, //内容删除
    deleteArticleInfo(type, id) {
      this.$api
        .post("/admin/Article/DelateArticle?type=" + type + "&id=" + id)
        .then(res => {
          if (res.succeed) {
            this.$message.success("操作成功！");
            this.getArticleList(type, this.currentPage, this.currentSize);
          } else {
            this.$message.error(res.error);
          }
        });
    },
    see(val, type) {
      this.centerDialogVisible = true;
      this.getArticleInfo(type, val.id);
    },
    shield(val, type) {
      this.$confirm("你确定要屏蔽这条内容吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.updateArticleInfo(type, val.id, 1);
        })
        .catch(() => {});
    },
    shieldRecover(val, type) {
      this.$confirm("你确定要取消屏蔽这条内容吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.updateArticleInfo(type, val.id, 0);
        })
        .catch(() => {});
    },
    del(val, type) {
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteArticleInfo(type, val.id);
        })
        .catch(() => {});
    },
    //切换每页条数
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.currentSize = val;
      if (this.activeName == 0) {
        this.getArticleList(1, this.currentPage, this.currentSize);
      } else if (this.activeName == 1) {
        this.getArticleList(2, this.currentPage, this.currentSize);
      } else if (this.activeName == 2) {
        this.getArticleList(3, this.currentPage, this.currentSize);
      }
    },
    //切换页码
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val;
      if (this.activeName == 0) {
        this.getArticleList(1, this.currentPage, this.currentSize);
      } else if (this.activeName == 1) {
        this.getArticleList(2, this.currentPage, this.currentSize);
      } else if (this.activeName == 2) {
        this.getArticleList(3, this.currentPage, this.currentSize);
      }
    },
    //动态获取url
    getUrl(url, queryConfig) {
      //var queryConfig={"page" : "index", "method" : 2}
      var that = this;
      var _str = "";
      for (var obj in queryConfig) {
        if (!that.isNull(queryConfig[obj])) {
          _str += obj + "=" + queryConfig[obj] + "&";
        }
      }
      return url + _str.substring(0, _str.length - 1);
    },
    //判空方法
    isNull(val = "") {
      if (val == undefined || val == null) {
        return true;
      }
      var str = val.toString().replace(/(^\s*)|(\s*$)/g, ""); //去除空格;
      if (str == "" || str == undefined || str == null) {
        return true;
      }
    },
    publishMsgHanle() {
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.initEditor();
      });
    },
    initEditor() {
      // this.editor = new E("#editor-container");

      // 通过 this.$refs 获取 DOM 节点
      const editorDom = this.$refs.editorContainer;
      if (!editorDom) {
        console.error("未找到编辑器容器节点");
        return;
      }
      this.editor = new E(editorDom); // 传入 DOM 节点而非选择器

      // 配置 editor
      this.editor.config.zIndex = 100;
      this.editor.config.uploadImgServer = window.api.apiurl;
      this.editor.config.uploadImgHeaders = this.uploadHeaders;
      this.editor.config.uploadImgMaxSize = 5 * 1024 * 1024; // 5MB
      this.editor.config.uploadImgMaxLength = 1; // 最多上传1张图片
      this.editor.config.uploadImgTimeout = 30 * 1000; // 30s timeout

      // 自定义上传文件名
      this.editor.config.uploadFileName = "file";

      // 事件处理
      this.editor.config.onchange = html => {
        this.form.content = html;
      };

      this.editor.create();
    },
    handleClose() {
      this.coverSet.Key = "";
      this.coverSet.IsEnable = undefined;
      this.coverDialogSet = false;
    },

    coverSearch() {
      this.coverPagination.currentPage = 1; // 重置为第一页
      this.fetchAdminList();
    },
    // 重置修改表单
    resetEditForm() {
      this.editForm = {
        id: "",
        name: "",
        coverUrl: ""
      };
      this.editCoverFileList = [];
    },
    dialogSetHandle() {
      this.coverDialogSet = true;
      this.coverTitle = "默认封面设置";
      this.fetchAdminList();
    },
    useDefaultCover() {
      this.coverDialogSet = true;
      this.coverTitle = "选择封面设置";
      this.fetchAdminList();
    },
    // 打开新增弹窗
    openAddDialog() {
      this.addDialogVisible = true;
    },

    // 处理新增封面上传
    handleAddCoverUpload(file, fileList) {
      if (file.status === "success") {
        this.addForm.coverUrl = file.response.data; // 根据接口返回结构调整
      }
      if (fileList.length > 0) {
        this.addCoverFileList = [fileList[fileList.length - 1]];
      }
    },

    // 处理新增封面移除
    handleAddCoverRemove(file, fileList) {
      this.addForm.coverUrl = "";
      this.addCoverFileList = fileList;
    },

    // 提交新增表单
    submitAddForm() {
      if (!this.addForm.name || !this.addForm.coverUrl) {
        this.$message.error("请填写图片名称并上传图片");
        return;
      }

      const params = {
        coverName: this.addForm.name,
        coverImage: this.addForm.coverUrl
      };

      AddJournaArticleCoverReq(params)
        .then(res => {
          if (res.succeed) {
            this.$message.success("新增成功");
            this.addDialogVisible = false;
            this.fetchAdminList(); // 刷新列表
          } else {
            this.$message.error(res.error);
          }
        })
        .catch(err => {
          console.error("新增失败:", err);
          this.$message.error("新增失败");
        });
    },

    // 重置新增表单
    resetAddForm() {
      this.addForm = {
        name: "",
        coverUrl: ""
      };
      this.addCoverFileList = [];
    },

    // 打开修改弹窗
    openEditDialog(row) {
      this.editDialogVisible = true;

      // 将当前行的数据填充到表单中
      this.editForm = {
        id: row.id,
        name: row.coverName,
        coverUrl: row.coverImage
      };

      // 初始化上传文件列表
      this.editCoverFileList = [
        {
          name: row.coverName,
          url: this.fullCoverImageUrl(row.coverImage)
        }
      ];
    },
    //使用此模版
    useCover(row) {
      this.form.cover = row.coverImage; // 假设接口返回格式为 { data: 'url' }
      this.fileList = [
        {
          name: row.coverName,
          url: this.fullCoverImageUrl(row.coverImage)
        }
      ];
      this.coverDialogSet = false;
    },
    // 处理修改封面上传
    handleEditCoverUpload(file, fileList) {
      if (file.status === "success") {
        this.editForm.coverUrl = file.response.data; // 根据接口返回结构调整
      }
      if (fileList.length > 0) {
        this.editCoverFileList = [fileList[fileList.length - 1]];
      }
    },

    // 处理修改封面移除
    handleEditCoverRemove(file, fileList) {
      this.editForm.coverUrl = "";
      this.editCoverFileList = fileList;
    },

    // 处理修改封面移除
    handleEditCoverRemove(file, fileList) {
      this.editForm.coverUrl = "";
      this.editCoverFileList = fileList;
    },

    // 提交修改表单
    submitEditForm() {
      if (!this.editForm.name || !this.editForm.coverUrl) {
        this.$message.error("请填写图片名称并上传图片");
        return;
      }

      const params = {
        id: this.editForm.id,
        coverName: this.editForm.name,
        coverImage: this.editForm.coverUrl
      };

      UpdateJournaArticleCoverReq(params)
        .then(res => {
          if (res.succeed) {
            this.$message.success("修改成功");
            this.editDialogVisible = false;
            this.fetchAdminList(); // 刷新列表
          } else {
            this.$message.error(res.error);
          }
        })
        .catch(err => {
          console.error("修改失败:", err);
          this.$message.error("修改失败");
        });
    },

    // 启用/禁用封面
    toggleCoverStatus(row) {
      this.$confirm(
        `确定要${row.isEnable ? "禁用" : "启用"}该封面吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          const params = {
            id: row.id,
            isEnable: !row.isEnable
          };

          DisableOrEnableJournaArticleCoverReq(params)
            .then(res => {
              if (res.succeed) {
                this.$message.success("操作成功");
                this.fetchAdminList(); // 刷新列表
              } else {
                this.$message.error(res.error);
              }
            })
            .catch(err => {
              console.error("操作失败:", err);
              this.$message.error("操作失败");
            });
        })
        .catch(() => {
          this.$message.info("已取消操作");
        });
    },

    // 获取默认封面列表
    fetchAdminList() {
      const params = {
        Key: this.coverSet.Key,
        IsEnable: this.coverSet.IsEnable,
        PageIndex: this.coverPagination.currentPage,
        PageSize: this.coverPagination.pageSize
      };

      GetJournaArticleCoverListReq(params)
        .then(res => {
          if (res.succeed) {
            this.adminList = res.data.data;
            this.coverPagination.total = res.data.total;
          } else {
            this.$message.error(res.error);
          }
        })
        .catch(err => {
          console.error("获取列表失败:", err);
          this.$message.error("获取列表失败");
        });
    },
    // 处理封面列表分页变化
    handleCoverPageChange(currentPage) {
      this.coverPagination.currentPage = currentPage;
      this.fetchAdminList();
    },

    // 处理封面列表每页条数变化
    handleCoverSizeChange(pageSize) {
      this.coverPagination.pageSize = pageSize;
      this.coverPagination.currentPage = 1; // 重置为第一页
      this.fetchAdminList();
    }
  },
  computed: {
    fullCoverImageUrl() {
      return url => {
        if (!url) return "";
        return `${window.api.apiurl}${url}`;
      };
    }
  },
  components: {
    contentDetail,
    wordEdit
  }
};
</script>

<style lang="scss" scoped>
.table {
  margin-top: 0.2rem;
  padding: 0.24rem 0.19rem 0.3rem 0.2rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.05rem;
}
.filter {
  padding: 0.25rem 0.19rem 0.23rem 0.2rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.05rem;
  display: flex;
  justify-content: space-between;
  >>> .el-form-item {
    margin-bottom: 0;
  }
}
.section {
  padding: 0.23rem 0.18rem 0.57rem;
  flex: 1 1 2.4rem;
  border-radius: 0.06rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 1.4rem;
  .name {
    color: rgb(102, 102, 102);
    font-size: 0.18rem;
    font-family: Microsoft YaHei;
    line-height: 0.17rem;
  }
  .number {
    margin-top: 0.17rem;
    color: rgb(51, 51, 51);
    font-size: 0.32rem;
    font-family: Microsoft YaHei;
    line-height: 0.26rem;
  }
}
 >>> .el-dialog__body {
  max-height: 70vh !important;
  }
</style>



// WEBPACK FOOTER //
// src/view/contentManagement/allContent.vue